import React from 'react';
import Equipamentos from './Equipamentos';

export default function ProdutosQuimicos() {
    return <Equipamentos categoriaInicial="quimicos" />;
}
